module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_7.961ede76.mp3";